module.exports = __webpack_public_path__ + "static/Lidl-b9dde75f5d987a966a259384c4c65662.webp";